module.exports = __webpack_public_path__ + "img/about_over.62048f01.gif";